module.exports = __webpack_public_path__ + "static/media/servers.b3c19261.svg";